import { render, staticRenderFns } from "./Container.component.vue?vue&type=template&id=2218b759"
var script = {}
import style0 from "./Container.component.vue?vue&type=style&index=0&id=2218b759&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports